"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopupMenu = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var constants_1 = require("./constants");
var collection_1 = require("./collection");
var popup_control_1 = require("./popup-control");
var PopupMenu = /** @class */function (_super) {
  __extends(PopupMenu, _super);
  function PopupMenu() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._items = new collection_1.Collection();
    _this._renderedItems = [];
    _this._selectedIndex = -1;
    return _this;
  }
  PopupMenu.prototype.renderContent = function () {
    var element = document.createElement("div");
    element.className = this.hostConfig.makeCssClassName("ac-ctrl ac-popup");
    element.setAttribute("role", "listbox");
    for (var i = 0; i < this._items.length; i++) {
      var renderedItem = this._items.get(i).render(this.hostConfig);
      renderedItem.tabIndex = 0;
      element.appendChild(renderedItem);
      if (i == 0) {
        renderedItem.setAttribute("aria-expanded", "true");
      }
      if (i === this.selectedIndex) {
        renderedItem.focus();
      }
      this._renderedItems.push(renderedItem);
    }
    return element;
  };
  PopupMenu.prototype.keyDown = function (e) {
    _super.prototype.keyDown.call(this, e);
    var selectedItemIndex = this._selectedIndex;
    switch (e.key) {
      case constants_1.Constants.keys.tab:
        this.closePopup(true);
        break;
      /*
      case Constants.keys.enter:
          if (this.selectedIndex >= 0) {
              this.selectedIndex = this.selectedIndex;
                this.close();
          }
            break;
      */
      case constants_1.Constants.keys.up:
        if (selectedItemIndex <= 0) {
          selectedItemIndex = this._renderedItems.length - 1;
        } else {
          selectedItemIndex--;
          if (selectedItemIndex < 0) {
            selectedItemIndex = this._renderedItems.length - 1;
          }
        }
        this.selectedIndex = selectedItemIndex;
        this.removeAriaExpanded(selectedItemIndex);
        e.cancelBubble = true;
        break;
      case constants_1.Constants.keys.down:
        if (selectedItemIndex < 0) {
          selectedItemIndex = 0;
        } else {
          selectedItemIndex++;
          if (selectedItemIndex >= this._renderedItems.length) {
            selectedItemIndex = 0;
          }
          this.removeAriaExpanded(selectedItemIndex);
        }
        this.selectedIndex = selectedItemIndex;
        e.cancelBubble = true;
        break;
    }
  };
  Object.defineProperty(PopupMenu.prototype, "items", {
    get: function () {
      return this._items;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PopupMenu.prototype, "selectedIndex", {
    get: function () {
      return this._selectedIndex;
    },
    set: function (index) {
      if (index >= 0 && index < this._renderedItems.length) {
        this._renderedItems[index].focus();
        this._selectedIndex = index;
      }
    },
    enumerable: false,
    configurable: true
  });
  // remove aria-expanded attribute from menu item
  PopupMenu.prototype.removeAriaExpanded = function (index) {
    if (this._renderedItems[index].getAttribute("aria-expanded") === "true") {
      this._renderedItems[index].removeAttribute("aria-expanded");
    }
  };
  return PopupMenu;
}(popup_control_1.PopupControl);
exports.PopupMenu = PopupMenu;